module.exports = __webpack_public_path__ + "static/img/loginpost.cb20793.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/loginpost.png
// module id = DxBm
// module chunks = 1